function ShowRoundBtn() {
	$PreviewBtn = $('#preview-product');
	var OffsetTop = $('.add-product__body').offset().top;
	
	if( windowWidth <= SCREEN.SM ) {
		if ($(window).scrollTop() > OffsetTop) {
			$PreviewBtn.addClass('show');
		} else {
			$PreviewBtn.removeClass('show');
		}
	}
	
	$(window).scroll(function(){
		if( windowWidth <= SCREEN.SM ){
			if ($(window).scrollTop() > OffsetTop){
				$PreviewBtn.addClass('show');
			}else{
				$PreviewBtn.removeClass('show');
			}
		}
	});
}

$(function() {
	if ($('.page-add-product').length > 0) {
		ShowRoundBtn();
	}
});